import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Box as Container } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { LogoHeader } from 'components/header/LogoHeader'
import { PathNames } from 'constants/General'
import { VerificationResult } from 'types/verification'

const VerificationStatus = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { status: statusParam } = useParams() || {}

  const status = statusParam?.toLowerCase() as VerificationResult
  const isVerificationSuccessful = status === VerificationResult.SUCCESS

  const statusMatch = Object.values(VerificationResult)?.includes(status)

  useEffect(() => {
    if (!statusMatch) {
      navigate(PathNames.NOT_FOUND, { replace: true })
    }
  }, [statusMatch])

  return (
    <Container height="screen" width="full" flexCol>
      <LogoHeader />
      <Box paddingX={60} className="bg-surface-static h-full">
        <Box height="full" flexCol justify="center" paddingX={16} gap={32} className="sm:px-16">
          <Lottie src={isVerificationSuccessful ? 'verified' : 'permissions-denied'} />
          <h1 className="text-h1 text-foreground-prominent">
            {isVerificationSuccessful
              ? t('verificationStatus.successful')
              : t('verificationStatus.unsuccessful')}
          </h1>
        </Box>
      </Box>
    </Container>
  )
}

export default VerificationStatus
